import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
echarts.use([TooltipComponent, PieChart]);

interface TortaMovimientosProps {
  cap: number;
  ea: number;
  fam: number;
  geo: number;
  is: number;
  isv: number;
  lrac: number;
  msj: number;
  sag: number;
  smn: number;
  zcc: number;
}

const getDefaultOptions = (
  getThemeColor: (name: string) => string,
  isDark: boolean,
  props: TortaMovimientosProps
) => ({
  color: [
    !isDark ? getThemeColor('info-light') : getThemeColor('info-dark'),
    !isDark ? getThemeColor('warning-light') : getThemeColor('warning-dark'),
    !isDark ? getThemeColor('danger-light') : getThemeColor('danger-dark'),
    !isDark ? getThemeColor('success-light') : getThemeColor('success-dark'),
    getThemeColor('primary'),
    !isDark ? getThemeColor('info-light') : getThemeColor('info-dark'),
    !isDark ? getThemeColor('warning-light') : getThemeColor('warning-dark'),
    !isDark ? getThemeColor('danger-light') : getThemeColor('danger-dark'),
    !isDark ? getThemeColor('success-light') : getThemeColor('success-dark'),
    getThemeColor('primary'),
    !isDark ? getThemeColor('info-light') : getThemeColor('info-dark')
  ],
  tooltip: {
    trigger: 'item'
  },
  responsive: true,
  maintainAspectRatio: false,
  series: [
    {
      name: 'Movimientos',
      type: 'pie',
      radius: ['48%', '90%'],
      startAngle: 30,
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
        formatter: '{x|{d}%} \n {y|{b}}',
        rich: {
          x: {
            fontSize: 31.25,
            fontWeight: 800,
            color: getThemeColor('tertiary-color'),
            padding: [0, 0, 5, 15]
          },
          y: {
            fontSize: 12.8,
            color: getThemeColor('tertiary-color'),
            fontWeight: 600
          }
        }
      },
      emphasis: {
        label: {
          show: true
        }
      },
      labelLine: {
        show: false
      },
      data: [
        { value: props.cap, name: 'CAP' },
        { value: props.ea, name: 'EA' },
        { value: props.fam, name: 'FAM' },
        { value: props.geo, name: 'GEO' },
        { value: props.is, name: 'IS' },
        { value: props.isv, name: 'ISV' },
        { value: props.lrac, name: 'LRAC' },
        { value: props.msj, name: 'MSJ' },
        { value: props.sag, name: 'SAG' },
        { value: props.smn, name: 'SMN' },
        { value: props.zcc, name: 'ZCC' }
      ]
    }
  ],
  grid: {
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    containLabel: false
  }
});

const TortaMovimientos = ({ cap, ea, fam, geo, is, isv, lrac, msj, sag, smn, zcc }: TortaMovimientosProps) => {
  const {
    getThemeColor,
    config: { isDark }
  } = useAppContext();

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getDefaultOptions(getThemeColor, isDark, { cap, ea, fam, geo, is, isv, lrac, msj, sag, smn, zcc })}
      style={{ minHeight: '390px', width: '100%' }}
    />
  );
};

export default TortaMovimientos;